/* QGC Future look - behaviour.
   1. Light / dark toggle with a circular reveal from the button.
   2. Contrast guard: keeps every piece of text (and its hover state) readable in both modes. In dark mode it also turns
      leftover white panels dark. It never touches photos, gradients or the green panels, which are styled already.
   3. Search: tapping the bar search smoothly opens it in place (no page blur); Ctrl/Cmd+K or "/" focuses it.
   4. Motion: scroll progress line, header shadow on scroll, scroll reveals + counters, staggered product cards,
      card tilt + glow, button ripples.
   5. Product page: size buttons for Retail and the sticky mobile buy bar. */
(function(){
  var root = document.documentElement;
  var mq = function(q){ return window.matchMedia && matchMedia(q).matches; };
  var reduce = mq('(prefers-reduced-motion: reduce)');
  var fine = mq('(pointer: fine)') && !reduce;
  function $(s, c){ return (c || document).querySelector(s); }
  function $$(s, c){ return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function dark(){ return root.getAttribute('data-theme') === 'dark'; }

  /* ===================== Contrast guard ===================== */
  var LIGHT = [238, 245, 236], DARK = [20, 32, 26], SURFACE_DARK = 'rgb(16, 32, 24)';
  function parse(c){ var m = c && c.match(/rgba?\(([^)]+)\)/); if(!m) return null; var p = m[1].split(/[\s,\/]+/).filter(Boolean).map(parseFloat); return [p[0], p[1], p[2], p.length > 3 ? p[3] : 1]; }
  function lum(c){ var a = [c[0], c[1], c[2]].map(function(v){ v /= 255; return v <= .03928 ? v / 12.92 : Math.pow((v + .055) / 1.055, 2.4); }); return .2126 * a[0] + .7152 * a[1] + .0722 * a[2]; }
  function ratio(a, b){ var x = lum(a), y = lum(b); return (Math.max(x, y) + .05) / (Math.min(x, y) + .05); }
  function mix(top, under){ var a = top[3]; return [top[0] * a + under[0] * (1 - a), top[1] * a + under[1] * (1 - a), top[2] * a + under[2] * (1 - a), 1]; }
  function pageBg(){ return parse(getComputedStyle(document.body).backgroundColor) || (dark() ? [7, 17, 11, 1] : [243, 246, 240, 1]); }
  /* Effective background behind an element. Returns null when a photo or gradient is involved (styled by hand). */
  function bgOf(el){
    var layers = [];
    for(var n = el; n && n.nodeType === 1; n = n.parentElement){
      var cs = getComputedStyle(n);
      if(cs.backgroundImage && cs.backgroundImage !== 'none') return null;
      var c = parse(cs.backgroundColor);
      if(c && c[3] > 0){ layers.push(c); if(c[3] >= .98) break; }
      if(n === document.body) break;
    }
    var base = (layers.length && layers[layers.length - 1][3] >= .98) ? layers.pop() : pageBg();
    for(var i = layers.length - 1; i >= 0; i--) base = mix(layers[i], base);
    return base;
  }
  function hasOwnText(el){
    for(var c = el.firstChild; c; c = c.nextSibling){ if(c.nodeType === 3 && c.nodeValue.trim()) return true; }
    return /^(A|BUTTON|SUMMARY|LABEL)$/.test(el.tagName) && !!el.querySelector('svg');
  }
  var SKIP = 'script,style,noscript,svg,img,video,iframe,canvas,[data-fx-keep],.qbar-mode,.fx-grad,.fx-tile,.fx-coll-hero,.fx-band,.fx-hcard,.fx-ambient';
  function fixText(el, mark){
    if(el.closest(SKIP)) return;
    var cs = getComputedStyle(el);
    if(cs.visibility === 'hidden' || cs.display === 'none' || +cs.opacity === 0) return;
    var fg = parse(cs.color); if(!fg) return;
    var bg = bgOf(el); if(!bg) return;
    var f = fg[3] < 1 ? mix(fg, bg) : fg;
    var need = parseFloat(cs.fontSize) >= 22 ? 3 : 4.2;
    if(ratio(f, bg) >= need) return;
    var pick = ratio(LIGHT, bg) >= ratio(DARK, bg) ? LIGHT : DARK;
    el.style.setProperty('color', 'rgb(' + pick.join(',') + ')', 'important');
    el.setAttribute(mark, '1');
  }
  function fixSurface(el){
    if(el.closest(SKIP) || el === document.body || el === root) return;
    var cs = getComputedStyle(el);
    if(cs.backgroundImage && cs.backgroundImage !== 'none') return;
    var c = parse(cs.backgroundColor);
    if(!c || c[3] < .6 || lum(c) < .72) return;
    if(el.offsetWidth < 24 || el.offsetHeight < 16) return; /* tiny dots, swatches */
    el.style.setProperty('background-color', SURFACE_DARK, 'important');
    el.setAttribute('data-fx-s', '1');
  }
  function clearFixes(scope){
    $$('[data-fx-c]', scope).forEach(function(el){ el.style.removeProperty('color'); el.removeAttribute('data-fx-c'); });
    $$('[data-fx-s]', scope).forEach(function(el){ el.style.removeProperty('background-color'); el.removeAttribute('data-fx-s'); });
  }
  function guard(scope){
    scope = scope || document.body;
    var els = scope.nodeType === 1 ? [scope].concat($$('*', scope)) : $$('*', scope);
    if(dark()) els.forEach(fixSurface);
    els.forEach(function(el){ if(el.nodeType === 1 && hasOwnText(el)) fixText(el, 'data-fx-c'); });
  }
  var guardTimer = null;
  function guardSoon(){ clearTimeout(guardTimer); guardTimer = setTimeout(function(){ guard(document.body); }, 120); }
  /* Hover / focus: check the hovered control after its colour transition and fix only while hovered */
  var hoverEl = null;
  function hoverCheck(el){
    if(!el) return;
    setTimeout(function(){
      if(hoverEl !== el) return;
      [el].concat($$('*', el)).forEach(function(n){ if(hasOwnText(n) && !n.hasAttribute('data-fx-c')) fixText(n, 'data-fx-h'); });
    }, 260);
  }
  function hoverClear(el){ if(!el) return; [el].concat($$('[data-fx-h]', el)).forEach(function(n){ if(n.hasAttribute && n.hasAttribute('data-fx-h')){ n.style.removeProperty('color'); n.removeAttribute('data-fx-h'); } }); }
  document.addEventListener('pointerover', function(e){
    var t = e.target.closest && e.target.closest('a,button,summary,label,.tf-value,.state-option,.hs-item,[role="button"]');
    if(t === hoverEl) return;
    hoverClear(hoverEl); hoverEl = t; hoverCheck(t);
  }, { passive: true });
  document.addEventListener('focusin', function(e){ var t = e.target.closest && e.target.closest('a,button,summary,input,select'); if(t){ hoverEl = t; hoverCheck(t); } });

  /* ===================== Light / dark toggle ===================== */
  var tb = document.getElementById('fxThemeBtn');
  var actions = $('.qgc-bar .header-actions');
  if(tb && actions) actions.insertBefore(tb, actions.firstChild);
  var MOON = '<path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z"/>';
  var SUN = '<circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/>';
  function paintIcon(){ var i = document.getElementById('fxThemeIcon'); if(i) i.innerHTML = dark() ? SUN : MOON; if(tb) tb.setAttribute('aria-pressed', dark() ? 'true' : 'false'); }
  paintIcon();
  if(tb) tb.addEventListener('click', function(e){
    var next = dark() ? 'light' : 'dark';
    try{ localStorage.setItem('qgc_theme', next); }catch(x){}
    var go = function(){ clearFixes(document.body); root.setAttribute('data-theme', next); paintIcon(); setTimeout(function(){ guard(document.body); }, 700); };
    if(document.startViewTransition && !reduce){
      var r = tb.getBoundingClientRect(), x = r.left + r.width / 2, y = r.top + r.height / 2;
      var end = Math.hypot(Math.max(x, innerWidth - x), Math.max(y, innerHeight - y));
      var vt = document.startViewTransition(go);
      vt.ready.then(function(){
        root.animate({ clipPath: ['circle(0px at ' + x + 'px ' + y + 'px)', 'circle(' + end + 'px at ' + x + 'px ' + y + 'px)'] }, { duration: 650, easing: 'cubic-bezier(.2,.8,.2,1)', pseudoElement: '::view-transition-new(root)' });
      }).catch(function(){});
    } else go();
  });

  /* ===================== Search: smooth open in place ===================== */
  var form = document.getElementById('hdrSearch'), input = document.getElementById('hdrSearchInput');
  if(form && input){
    var open = function(){ form.classList.add('fx-open'); };
    var shut = function(){ form.classList.remove('fx-open'); };
    input.addEventListener('focus', open);
    form.addEventListener('focusout', function(e){ if(!form.contains(e.relatedTarget)) setTimeout(function(){ if(!form.contains(document.activeElement)) shut(); }, 150); });
    document.addEventListener('keydown', function(e){
      var k = (e.key || '').toLowerCase(), a = document.activeElement || {};
      var typing = /^(input|textarea|select)$/i.test(a.tagName || '') || a.isContentEditable;
      if(((e.metaKey || e.ctrlKey) && k === 'k') || (k === '/' && !typing)){
        e.preventDefault();
        if(form.getBoundingClientRect().top < 0 || form.getBoundingClientRect().top > innerHeight) form.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        input.focus({ preventScroll: true });
      } else if(k === 'escape' && form.contains(a)){ input.blur(); shut(); }
    });
    if(window.MutationObserver){ var box = document.getElementById('hdrSuggest'); if(box) new MutationObserver(function(){ if(!box.hidden) guard(box); }).observe(box, { childList: true }); }
  }

  /* ===================== Scroll: progress line + header shadow + sticky buy bar ===================== */
  var bar = document.getElementById('fxProgress'), hdr = document.getElementById('header-component'), ticking = false;
  function onScroll(){
    ticking = false;
    var h = document.documentElement.scrollHeight - innerHeight;
    if(bar) bar.style.transform = 'scaleX(' + (h > 0 ? Math.min(1, scrollY / h) : 0) + ')';
    if(hdr) hdr.classList.toggle('fx-scrolled', scrollY > 24);
    var sb = document.getElementById('fxStickyBuy'); if(sb) sb.classList.toggle('show', scrollY > 650);
  }
  addEventListener('scroll', function(){ if(!ticking){ ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });

  /* ===================== Reveals, counters, staggered cards ===================== */
  function countUp(el){
    var to = parseInt(el.getAttribute('data-count'), 10) || 0, t0 = performance.now();
    if(reduce){ el.textContent = to.toLocaleString('en-AU'); return; }
    (function step(t){ var k = Math.min(1, (t - t0) / 1400); el.textContent = Math.round(to * (1 - Math.pow(1 - k, 3))).toLocaleString('en-AU'); if(k < 1) requestAnimationFrame(step); })(t0);
  }
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function(es){
    es.forEach(function(e){
      if(!e.isIntersecting) return;
      var t = e.target; io.unobserve(t);
      if(t.classList.contains('tag-card')){ var d = +(t.getAttribute('data-fx-d') || 0); setTimeout(function(){ t.classList.add('fx-in'); t.classList.remove('fx-in-wait'); }, d); return; }
      t.classList.add('in'); $$('[data-count]', t).forEach(countUp);
    });
  }, { threshold: .12, rootMargin: '0px 0px -40px 0px' }) : null;
  function initReveal(scope){
    if(!io){ $$('.fx-reveal', scope).forEach(function(el){ el.classList.add('in'); }); $$('[data-count]', scope).forEach(countUp); return; }
    $$('.fx-reveal:not(.in), .fx-countbox', scope).forEach(function(el){ io.observe(el); });
    if(!reduce) $$('.qgc .prod-grid .tag-card:not(.fx-in):not(.fx-in-wait)', scope).forEach(function(c, i){
      var r = c.getBoundingClientRect(); if(r.top < innerHeight && r.bottom > 0 && document.readyState === 'complete') { c.classList.add('fx-in'); return; }
      c.classList.add('fx-in-wait'); c.setAttribute('data-fx-d', (i % 4) * 70); io.observe(c);
    });
  }

  /* ===================== Card tilt + glow, button ripple ===================== */
  function bindTilt(scope){
    if(!fine) return;
    $$('.qgc .tag-card', scope).forEach(function(c){
      if(c.__fx) return; c.__fx = 1;
      c.addEventListener('mousemove', function(e){ var r = c.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height; c.style.setProperty('--mx', x * 100 + '%'); c.style.setProperty('--my', y * 100 + '%'); c.style.transform = 'perspective(900px) rotateX(' + ((.5 - y) * 5) + 'deg) rotateY(' + ((x - .5) * 7) + 'deg) translateY(-4px)'; });
      c.addEventListener('mouseleave', function(){ c.style.transform = ''; });
    });
  }
  document.addEventListener('pointermove', function(e){ var b = e.target.closest && e.target.closest('.fx-btn'); if(b){ var r = b.getBoundingClientRect(); b.style.setProperty('--mx', (e.clientX - r.left) + 'px'); b.style.setProperty('--my', (e.clientY - r.top) + 'px'); } }, { passive: true });
  if(!reduce) document.addEventListener('pointerdown', function(e){
    var b = e.target.closest && e.target.closest('.fx-btn, .qgc .btn-quote-main, .qgc .quote-trigger, .qgc .state-select, .fx-theme-btn, .fx-opt, .fx-size');
    if(!b) return;
    var r = b.getBoundingClientRect(), s = Math.max(r.width, r.height) * 2;
    if(getComputedStyle(b).position === 'static') b.style.position = 'relative';
    b.style.overflow = 'hidden';
    var dot = document.createElement('span'); dot.className = 'fx-ripple';
    dot.style.cssText = 'width:' + s + 'px;height:' + s + 'px;left:' + (e.clientX - r.left - s / 2) + 'px;top:' + (e.clientY - r.top - s / 2) + 'px';
    b.appendChild(dot); setTimeout(function(){ dot.remove(); }, 650);
  });

  /* ===================== Product page ===================== */
  function initProduct(){
    var sel = document.getElementById('qgcRetailVariant');
    if(sel && !sel.__fx){
      sel.__fx = 1;
      var wrap = document.createElement('div'); wrap.className = 'fx-sizes'; wrap.setAttribute('role', 'group'); wrap.setAttribute('aria-label', 'Size');
      Array.prototype.forEach.call(sel.options, function(o){
        var b = document.createElement('button'); b.type = 'button'; b.className = 'fx-size';
        b.innerHTML = '<b></b><small></small>';
        b.querySelector('b').textContent = o.textContent.replace(/\s*-\s*sold out$/i, '');
        b.querySelector('small').textContent = o.disabled ? 'Sold out' : (o.getAttribute('data-price') || '');
        b.disabled = o.disabled; b.setAttribute('aria-pressed', o.selected ? 'true' : 'false');
        b.addEventListener('click', function(){ sel.value = o.value; sel.dispatchEvent(new Event('change', { bubbles: true })); });
        wrap.appendChild(b);
      });
      sel.addEventListener('change', function(){ Array.prototype.forEach.call(wrap.children, function(b, i){ b.setAttribute('aria-pressed', sel.options[i].value === sel.value ? 'true' : 'false'); }); });
      sel.parentNode.insertBefore(wrap, sel);
      sel.closest('form').classList.add('fx-has-pills');
    }
    var h1 = $('.qgc .product-info h1');
    if(h1 && !document.getElementById('fxStickyBuy')){
      var sb = document.createElement('div'); sb.className = 'fx-sticky-buy'; sb.id = 'fxStickyBuy';
      sb.innerHTML = '<div><b></b><small></small></div><button type="button"></button>';
      sb.querySelector('b').textContent = h1.textContent.trim();
      var btn = sb.querySelector('button');
      var sync = function(){
        var retail = root.getAttribute('data-qgc-mode') === 'retail';
        var price = document.getElementById('qgcRetailPrice');
        sb.querySelector('small').textContent = retail ? (price ? price.textContent.trim() : '') : 'Trade pricing on quote';
        var rb = $('#qgcRetailForm button[type="submit"]');
        btn.textContent = retail ? (rb && rb.disabled ? 'Sold out' : 'Add to cart') : 'Choose sizes';
        btn.disabled = !!(retail && rb && rb.disabled);
      };
      btn.addEventListener('click', function(){
        var retail = root.getAttribute('data-qgc-mode') === 'retail';
        var target = retail ? $('#qgcRetailForm button[type="submit"]') : $('[data-size-quote], .qgc .quote-module');
        if(retail && target && !target.disabled){ target.click(); return; }
        if(target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      document.body.appendChild(sb); sync();
      document.addEventListener('qgc:modeChanged', sync); document.addEventListener('change', function(){ setTimeout(sync, 30); }); document.addEventListener('qgc:stateChanged', function(){ setTimeout(sync, 30); });
    }
  }

  /* ===================== Boot ===================== */
  function boot(){
    initProduct(); initReveal(document); bindTilt(document); onScroll();
    guard(document.body);
    /* Re-check when content changes: state sort re-renders cards, drawers open, quote list updates */
    if(window.MutationObserver){
      var pending = [];
      var mo = new MutationObserver(function(list){
        list.forEach(function(m){ m.addedNodes.forEach(function(n){ if(n.nodeType === 1 && !n.classList.contains('fx-ripple')) pending.push(n); }); });
        if(!pending.length) return;
        clearTimeout(mo.t); mo.t = setTimeout(function(){ var p = pending.splice(0); p.forEach(function(n){ if(n.isConnected){ guard(n); initReveal(n); bindTilt(n); } }); }, 80);
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
    ['qgc:modeChanged', 'qgc:stateChanged', 'cart:update'].forEach(function(ev){ document.addEventListener(ev, function(){ setTimeout(function(){ clearFixes(document.body); guard(document.body); }, 500); }); });
    document.addEventListener('click', function(e){ if(e.target.closest && e.target.closest('#openDrawer,#sendListBtn,[data-qgc-set-mode],#stateSelectBtn,.fx-opt')) setTimeout(guardSoon, 350); });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  addEventListener('load', function(){ guardSoon(); });
  document.addEventListener('shopify:section:load', function(e){ initReveal(e.target); bindTilt(e.target); guardSoon(); });
})();
